<template>
	<div v-if="!isCheckoutRoute && !isBirthKitForm" :class="[store.bannerChecked && !store.showBanner ? 'md2:pt-4' : '']">
		<!-- Mobile Menu -->
		<div
			v-if="!isCheckoutRoute && !isInvoiceTemplate && !isBirthKitForm"
			class="select-none w-full transition-all duration-500 transform-gpu bg-white shadow-lg fixed left-0 z-40 block md:hidden overflow-y-auto h-[calc(100vh-82px)] sm:h-[calc(100vh-80px)]"
			:class="[mobileNavOpen ? '' : 'translate-y-full pointer-events-none', store.showBanner ? 'top-[176px] md:top-[80px]' : 'top-[82px] sm:top-[80px]']"
			@click.stop
		>
			<div class="p-4">
				<div
					class="flex w-full relative shadow rounded-lg overflow-hidden group text-sm bg-gradient-to-b from-ihh-pink to-ihh-purple font-thin text-black shadow-md relative"
				>
					<!-- yourSearch? -->
					<input
						type="text"
						id="name"
						v-model="search.value"
						required
						class="px-3 mr-1 bg-transparent rounded-lg focus:border focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon w-full text-sm font-light text-black placeholder-ihh-gray relative"
						placeholder="Search the store"
						@keyup.enter="handleSearch"
					/>
					<button class="duration-100 transition bg-transparent hover:bg-ihh-salmon/40 rounded-r-lg right-0 p-3 border-ihh-slate-gray" @click="handleSearch">
						<img src="/images/ob-search0129.svg" class="w-6 h-6 duration-300 transition ease-in-out" alt="Search Icon" />
					</button>
				</div>
			</div>

			<div class="flex w-full justify-center text-center">
				<div class="flex w-full justify-center hidden md:flex text-sm items-center my-3 tracking-wide">
					<ul class="flex space-x-2 lg:space-x-12 lg:max-w-6xl items-center mx-2">
						<li
							class="text-ihh-midnight-gray hover:bg-ihh-midnight-gray hover:text-ihh-white rounded-md px-3 py-1 font-semibold"
							v-for="link in links"
							:key="link.name"
						>
							<router-link
								class="hover:text-blue-400 py-1 order-1"
								:class="[
									{
										'underline underline-offset-4': isActive(link.path),
									},
								]"
								:to="link.path"
								>{{ link.name }}</router-link
							>
						</li>
					</ul>
				</div>
			</div>

			<div
				v-for="link in links"
				:key="link.name"
				class="cursor-pointer group flex flex-col text-sm font-semibold whitespace-nowrap text-ihh-midnight-gray py-3 rounded group"
			>
				<div class="flex px-6" @click="mobileSubNavCategory = mobileSubNavCategory === link.name ? null : link.name">
					<router-link :to="link.path" @click.stop="closeMobileNav">
						{{ link.name }}
					</router-link>
					<span class="inline-flex w-full justify-end" v-if="link.subnav?.length">
						<!-- Sub-menu toggle -->
						<div class="flex flex-col md:hidden relative group">
							<div
								:class="{ d: mobileSubNavCategory === link.name, '!rotate-0': mobileSubNavCategory === link.name }"
								class="bg-ihh-midnight-gray py-px px-2 transition ease-in-out duration-300 -rotate-90 translate-y-[1.5px]"
							></div>
							<div class="bg-ihh-midnight-gray py-px px-2 transition ease-in-out duration-300"></div>
						</div>
					</span>
				</div>
				<!-- Sub-menu -->
				<div v-show="mobileSubNavCategory === link.name" class="bg-ihh-purple py-2 space-y-2 px-6 mt-3">
					<div v-for="sublink in link.subnav" :key="sublink.name" class="flex space-x-2 items-center">
						<div class="w-10 h-10 aspect-square rounded-lg bg-ihh-light-purple shrink-0 bg-center bg-contain aspect-square mix-blend-darken rounded-lg p-1">
							<div
								:style="`background-image: url(${sublink.images?.[0]?.url})`"
								class="w-full aspect-square bg-center bg-contain bg-no-repeat aspect-square mix-blend-darken rounded-lg"
							/>
						</div>
						<router-link @click.stop="closeMobileNav" :to="sublink.path">
							{{ sublink.name }}
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- end of Mobile menu dropdown/side -->

		<!-- in his hands new header by me -->
		<div v-if="!isCheckoutRoute && !isInvoiceTemplate" class="fixed md:sticky bg-white w-full justify-center z-30 top-0">
			<Banner />
			<!-- <SpringSaleBanner v-if="isSaleActive && showSpringSaleBanner" @hide-banner="hideSpringSaleBanner" /> -->
			<div
				v-if="store.editingKit?.id"
				class="fixed top-0 left-0 w-full py-4 text-center font-bold text-white px-4 z-50"
				:class="store.birthKitOptional ? 'bg-magnolia-400' : 'bg-melon-500'"
			>
				Editing Birth Kit {{ store.birthKitOptional ? 'Optional' : '' }} Items:
				<router-link :to="`/birthKits/${editingKitSlug}/edit`" class="underline">{{ store.editingKit?.name }}</router-link>
				<router-link
					:to="`/birthKits/${editingKitSlug}`"
					@click.stop="store.editingKit = null"
					class="float-right w-6 h-6 rounded-full border border-white flex items-center justify-center p-1"
				>
					<div class="items-center flex justify-center w-full relative">
						<div class="rotate-45 absolute bg-white w-full h-[2px]"></div>
						<div class="-rotate-45 bg-white w-full h-[2px]"></div>
					</div>
				</router-link>
			</div>

			<div class="flex w-full justify-center" :class="store.editingKit?.id ? 'pt-16' : 'pt-1'">
				<div class="flex justify-between text-black items-center my-2 w-full max-w-none md:max-w-8xl mx-4">
					<div class="flex-1">
						<div class="flex md:hidden space-x-4 cursor-pointer">
							<div @click.stop="mobileNavOpen = !mobileNavOpen" class="flex flex-col md:hidden">
								<div @click.stop="mobileNavOpen = !mobileNavOpen" class="flex flex-col md:hidden relative transition-transform duration-700 ease-in-out">
									<div v-if="!mobileNavOpen" class="bg-ihh-midnight-gray py-[1px] px-[12px] my-[3px]"></div>
									<div
										:class="{
											'rotate-45 absolute mt-3': mobileNavOpen,
										}"
										class="bg-ihh-midnight-gray py-[1px] px-[12px] my-[3px] transition-transform"
									></div>
									<div
										:class="{
											'-rotate-45 mt-3': mobileNavOpen,
										}"
										class="bg-ihh-midnight-gray py-[1px] px-[12px] my-[3px] transition-transform"
									></div>
								</div>
							</div>

							<button @click="showSearch = true">
								<img src="/images/ob-search0129.svg" class="w-[22px]" alt="Search Icon" />
							</button>
						</div>

						<div
							class="hidden md:flex cursor-pointer relative w-full sm:max-w-xs lg:min-w-[20rem] mr-5 relative rounded-lg overflow-hidden group text-sm bg-gradient-to-b from-ihh-pink to-ihh-purple font-thin text-black shadow-md relative"
							@click="showSearch = true"
						>
							<div class="px-3 mr-1 bg-transparent rounded-lg w-full text-sm font-light text-black text-ihh-gray text-start m-auto items-center">
								Search the store
							</div>
							<button class="duration-100 transition bg-transparent rounded-r-lg right-0 p-3 border-ihh-slate-gray">
								<img src="/images/ob-search0129.svg" class="w-5 h-5 duration-300 transition ease-in-out" alt="Search Icon" />
							</button>
						</div>
					</div>

					<div class="ml-5 w-full max-w-[90px] md:min-w-[160px] md:max-w-[225px]">
						<router-link to="/" class="w-full">
							<div class="w-full">
								<Logo class="w-full" />
							</div>
						</router-link>
					</div>

					<div class="flex flex-1 items-center justify-end lg:gap-x-4 xl:gap-x-12 text-ihh-slate-gray font-semibold">
						<router-link
							to="/help-center"
							class="transition-all hidden md:flex text-sm text-ihh-midnight-gray border-2 border-ihh-salmon px-8 py-3 rounded-lg hover:bg-ihh-salmon whitespace-nowrap font-semibold"
							>Help Center</router-link
						>

						<div class="relative inline-block mx-4" @mouseleave="isOpen = false">
							<div @mouseover="isOpen = true" class="flex-grow">
								<button @click="accountClickIsOpen()" class="flex text-gray-500 text-sm whitespace-no-wrap">
									<img src="/images/ob-user-0129.svg" class="w-6 m-auto inline-flex -mt-px" />
									<span v-if="!store.user?.id" class="hidden md:flex ml-1 whitespace-nowrap font-normal m-auto">Sign in</span>
									<span v-else class="hidden md:flex ml-1 whitespace-nowrap font-normal m-auto">Account</span>
								</button>

								<!-- Dropdown menu positioned below the button and centered -->
								<div v-if="store.user?.id" v-show="isOpen" class="absolute left-1/2 transform -translate-x-24 pt-3 md:pt-2 w-40 z-10">
									<div class="bg-[#f7f2f2] drop-shadow-lg rounded-lg p-4 font-semibold text-xs tracking-wide z-10">
										<div class="flex w-full justify-end">
											<div
												class="bg-[#f7f2f2] absolute top-0 left-1/2 transform translate-x-1/2 md:translate-x-10 -translate-y-2 w-4 h-4 rotate-45"
											></div>
										</div>

										<button
											@click="accountClickIsOpen()"
											class="w-full px-4 py-2 mb-2 bg-ihh-dark-salmon text-ihh-midnight-gray hover:bg-ihh-salmon rounded-lg text-center"
										>
											Account
										</button>
										<Login v-slot="{ logout }" :small="false" class="!p-0">
											<button
												class="w-full px-4 py-2 border-2 border-ihh-salmon hover:bg-ihh-salmon text-ihh-midnight-gray rounded-lg text-center"
												@click="logout"
												v-safe-html="`Sign out`"
											/>
										</Login>
									</div>
								</div>
							</div>
						</div>

						<button @click="toggleBag" class="flex text-gray-500 text-sm whitespace-no-wrap">
							<img v-show="!store.cartTotalItems" src="/images/ob-bag-0129.svg" class="w-6 m-auto inline-flex -mt-px" />
							<img v-show="store.cartTotalItems" src="/images/ob-bag-full-0129.svg" class="w-6 m-auto inline-flex -mt-px" />
							<span class="hidden md:flex ml-1 font-normal m-auto">Bag</span>
						</button>
					</div>
				</div>
			</div>

			<Search :show="showSearch" @hide="showSearch = false" :searchValue="search.value" :categoriesEnabled="true" />

			<div @mouseleave="hoverMenu = null" class="relative">
				<div class="flex w-full justify-center text-center">
					<div class="flex w-full justify-center hidden md:flex text-sm items-center my-3 tracking-wide">
						<ul class="flex space-x-2 xl:space-x-12 items-center mx-2">
							<li class="" v-for="link in links" :key="link.name">
								<router-link
									@click="hoverMenu = null"
									@mouseover="hoverMenu = link.name"
									class="text-ihh-midnight-gray hover:bg-ihh-midnight-gray hover:text-ihh-white rounded-md px-3 py-2 font-semibold flex w-full lg:whitespace-nowrap"
									:class="[
										{
											'underline underline-offset-4': isActive(link.path),
										},
									]"
									:to="link.path"
									>{{ link.name }}</router-link
								>

								<div
									class="absolute top-full -left-0 flex w-full justify-center bg-ihh-midnight-gray/50 backdrop-blur h-screen z-10 transition-opacity duration-300 ease-in-out"
									@mouseover="hoverMenu = null"
									:class="confirmedHoverMenu == link.name ? 'opacity-100' : 'opacity-0 -translate-y-[200vh] pointer-events-none'"
								>
									<div class="absolute flex w-full justify-center bg-ihh-white rounded-b-xl py-11" @mouseover.stop>
										<div class="w-full max-w-5xl">
											<!-- this is where the images and the text will go... I Think 😉 -->
											<div class="">
												<div class="w-full">
													<div class="flex w-full px-12">
														<div class="grid grid-cols-3 md:grid-cols-6 gap-10 min-w-fit md:min-w-0 w-full">
															<router-link
																@click="hoverMenu = null"
																class="w-full hover:scale-105 duration-300 transition ease-in-out group"
																v-for="link in link.subnav"
																:key="link.path"
																:to="link.path"
															>
																<div
																	class="relative group cursor-pointer flex w-full justify-center bg-ihh-light-purple group-hover:border-2 border-ihh-midnight-gray rounded-xl items-center p-1 overflow-hidden"
																>
																	<div
																		class="w-full bg-center bg-contain aspect-square mix-blend-darken rounded-lg"
																		:style="`background-image: url(${link.images?.[0]?.url})`"
																	/>
																</div>
																<div class="flex w-full justify-center mt-2 text-sm flex-col md:flex-row">
																	<div class="text-center font-semibold tracking-wide text-ihh-midnight-gray break-words">
																		{{ link.name }}
																	</div>
																</div>
															</router-link>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!-- bottom of menu -->

			<!-- Sidebar bag component - Nate -->
			<div
				class="h-screen fixed top-0 right-0 z-20 select-none w-full transition-colors transform-gpu ease-in-out duration-500 backdrop-blur"
				:class="store.showBag ? 'bg-ihh-midnight-gray/60' : 'translate-x-full pointer-events-none'"
				@click="store.showBag = false"
			>
				<Bag v-if="store.showBag" />
			</div>
		</div>
		<div v-if="!isCheckoutRoute && !isInvoiceTemplate" class="opacity-0 md:h-0" :class="store.editingKit?.id ? 'h-40' : 'h-24'" />
	</div>
</template>

<script>
import Logo from '../partials/logo.vue'
import Login from '../layout/login.vue'
import Subscribe from './subscribe.vue'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import Mango from '../../helpers/mango'
import { loadOrFallback } from '../../helpers/pageLoad'
import Bag from './bag.vue'
import Product from '../products/product.vue'
import Shipping from '../pages/ihh-items/shipping.vue'
import Search from '../layout/search.vue'
import Banner from '../layout/banner.vue'
import SpringSaleBanner from '../layout/banners/spring-sale.vue'
import getPlaceholderCategories from '../../../../config/helpers/placeholderCategories'

export default {
	components: { Logo, Login, Subscribe, Menu, MenuButton, MenuItems, MenuItem, Bag, Product, Shipping, Search, Banner, SpringSaleBanner },
	props: { hidden: { type: Boolean, default: false } },
	inject: ['store', 'darkMode'],
	data() {
		return {
			showSpringSaleBanner: false,
			searchTimeout: null,
			isOpen: false,
			closed: false,
			showSearch: false,
			hoverMenu: null,
			showLogin: false,
			showSearch: false,
			keyListener: null,
			search: {
				activeIndex: 0,
				value: null,
				results: [],
				categories: [],
				loading: false,
			},
			email: null,
			mobileNavOpen: false,
			mobileSubNavCategory: false,
			categories: getPlaceholderCategories() || [],
			confirmedHoverMenu: null,
			currentTime: new Date(),
			timeInterval: null,
		}
	},
	async mounted() {
		this.showSpringSaleBanner = !window.localStorage.getItem(`hideSpringSaleBanner`)
		// Injected by front/public/index.js on the first page load. Read it once, like
		// window.mainEntry in Mango.vue, so a later remount fetches fresh categories.
		let categories = window.categories
		window.categories = null
		if (!categories)
			categories = await loadOrFallback(
				() =>
					Mango.categories({
						search: { isVisible: true, treeId: { $lte: 1 } },
						limit: 999,
						fields: ['name', 'url', 'imageUrl', 'parentId', 'bcId', 'sortOrder', 'url', 'description', 'defaultProductSort'],
						sort: { sortOrder: 1 },
					}),
				this.categories,
			)
		if (!Array.isArray(categories)) categories = this.categories
		for (let c of categories) {
			c.subcategories = categories.filter((sc) => sc.parentId == c.bcId)
		}

		this.store.categories = categories
		this.categories = this.store.categories
		// this.categories.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))

		const brands = await loadOrFallback(
			() => Mango.brands({ limit: 999, fields: ['id', 'bcId', 'customUrl', 'name', 'imageUrl', 'metaDescription', 'pageTitle'] }),
			[],
		)
		this.store.brands = Array.isArray(brands) ? brands : []

		this.keyListener = function (e) {
			if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
				e.preventDefault() // present "Save Page" from getting triggered.
				this.showSearch = !this.showSearch
			}
		}

		document.addEventListener('keydown', this.keyListener.bind(this))

		// Set up a timer to update the currentTime every minute
		this.timeInterval = setInterval(() => {
			this.currentTime = new Date()
		}, 60000) // Update every minute (60000 ms)

		// Check for the banner
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyListener)

		// Clean up the interval when the component is destroyed
		if (this.timeInterval) {
			clearInterval(this.timeInterval)
		}
	},
	watch: {
		// Add a SLIGHT delay when opening for the first time
		hoverMenu(n) {
			if (!n) return (this.confirmedHoverMenu = n)
			if (this.confirmedHoverMenu) return (this.confirmedHoverMenu = n)
			setTimeout(() => {
				if (n == this.hoverMenu) return (this.confirmedHoverMenu = n)
			}, 100)
		},
		'store.cart.cartItems': {
			handler: 'handleCartChange',
			deep: true,
		},
		loggedIn() {
			if (this.loggedIn) {
				// Do not hijack checkout login — store.login.next may be stale from account menu
				if (this.isCheckoutRoute) return
				if (typeof this.store.login?.next == 'function') this.store.login.next()
				else if (this.store.login?.next) this.$router.push(this.store.login.next)
			}
		},
	},
	methods: {
		isActive(path) {
			return this.$route.path === path
		},
		accountClickIsOpen() {
			;(this.isOpen = false), this.handleAccountClick()
		},
		handleAccountClick() {
			if (this.store.user?.id) {
				this.$router.push('/account/settings')
			} else {
				this.store.login = { next: '/account/settings' } // Set the next path to /account
				if (this.$route.path !== '/login') {
					this.$router.push('/login')
				}
			}
		},
		toggleBag() {
			console.log('toggleBag clicked')
			this.store.showBag = !this.store.showBag
		},
		hideSpringSaleBanner() {
			this.showSpringSaleBanner = false
			window.localStorage.setItem(`hideSpringSaleBanner`, true)
			this.store.showSpringSaleBanner = false
		},
		handleSearch() {
			if (this.search.value) {
				this.mobileNavOpen = false
				this.showSearch = true
			}
		},
		closeMobileNav() {
			this.mobileNavOpen = false
			this.mobileSubNavCategory = null
		},
	},
	computed: {
		isSaleActive() {
			// Define start and end dates in Central Time
			const startDate = new Date('2025-04-25T18:15:00-05:00') // 6:15 PM CT on 4/25/25
			const endDate = new Date('2025-04-28T23:59:59-05:00') // 11:59 PM CT on 4/28/25

			// Use the reactive currentTime property instead of creating a new Date
			// This will cause the computed property to re-evaluate when currentTime changes

			// Check if current date is between start and end dates
			return this.currentTime >= startDate && this.currentTime <= endDate
		},
		links() {
			return this.categories
				.filter((c) => !c.parentId)
				.sort((a, b) => a.sortOrder - b.sortOrder)
				.map((c) => ({
					name: c.name,
					path: `/categories${c.url?.path}`,
					subnav: this.categories
						.filter((cc) => cc.parentId === c.bcId)
						.map((cc) => ({ name: cc.name, path: `/categories${cc.url?.path}`, images: [{ url: cc.imageUrl }] })),
				}))
		},
		loggedIn() {
			return this.store.user?.id
		},
		isLoginRoute() {
			return this.$route.path === '/login'
		},
		isCheckoutRoute() {
			return this.$route.path.includes('/checkout') || this.$route.path?.includes('/checkout/order-confirmation')
		},
		isInvoiceTemplate() {
			return this.$route.path.includes('/invoice/')
		},
		isBirthKitForm() {
			return this.$route.path.includes('/birth-kit-order-form')
		},
		editingKitSlug() {
			return this.store.editingKit?.customUrl?.url || this.store.editingKit?.slug || this.store.editingKit?.id
		},
	},
}
</script>
